var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 3.59375C14.5625 3.23828 14.2617 2.9375 13.9062 2.9375H2.09375C1.71094 2.9375 1.4375 3.23828 1.4375 3.59375V4.25H14.5625V3.59375ZM14.125 1.40625C14.125 1.05078 13.8242 0.75 13.4688 0.75H2.53125C2.14844 0.75 1.875 1.05078 1.875 1.40625V2.0625H14.125V1.40625ZM8 9.66406C7.53516 9.66406 7.17969 9.9375 7.17969 10.2656C7.17969 10.5938 7.53516 10.8672 8 10.8672C8.4375 10.8672 8.79297 10.5938 8.79297 10.2656C8.82031 9.9375 8.4375 9.66406 8 9.66406ZM14.125 5.125H1.875H1.84766C1.38281 5.125 0.972656 5.53516 0.972656 6C0.972656 6.02734 1 6.08203 1 6.08203L1.71094 13.957C1.73828 14.3945 2.14844 14.75 2.58594 14.75H13.3867C13.8242 14.75 14.2344 14.3945 14.2617 13.957L14.9727 6.08203C14.9727 6.08203 15 6.02734 15 6C15 5.53516 14.5898 5.125 14.125 5.125ZM8 13.6836C5.40234 13.6836 3.21484 12.207 3.07812 10.2656C2.94141 8.24219 5.12891 6.49219 8 6.49219C10.8438 6.49219 13.0312 8.24219 12.8945 10.2656C12.7578 12.207 10.5703 13.6836 8 13.6836Z",
    fill: "#A21D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSets);
export default __webpack_public_path__ + "static/media/sets.1360199ee4ed236e871bd8d204fcf78b.svg";
export { ForwardRef as ReactComponent };